const INITIAL_STATE = {
  theme: '',
};

const ActiveThemeReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'setActiveThemeAction':
      return { ...state, theme: action.payload };
    default:
      return state;
  }
};
export default ActiveThemeReducer;
